var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizzaquarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 477,
    viewBox: "0 0 588 477",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1739_827)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6289 -57.6386L449.654 3.83524L243.772 -313.243C316.828 -356.868 405.041 -376.034 495.628 -361.496C700.39 -328.632 839.742 -135.998 806.878 68.7642C774.015 273.527 581.381 412.878 376.619 380.015C171.856 347.151 32.5044 154.517 65.3679 -50.245C65.765 -52.7191 66.1854 -55.1837 66.6289 -57.6386Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.897 -48.2868L449.654 3.83528L275.67 -264.118C337.085 -300.438 411.024 -316.332 486.93 -304.149C659.792 -276.406 777.399 -113.562 749.611 59.5732C721.824 232.708 559.165 350.571 386.303 322.827C213.441 295.083 95.835 132.239 123.622 -40.8954C124.02 -43.3706 124.444 -45.8345 124.897 -48.2868Z",
    fill: "#FFD770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.869 92.8806C149.592 81.2638 122.476 82.9886 121.586 44.3595C109.482 -0.120689 106.136 58.591 97.4204 71.8777C88.7047 85.1645 124.079 158.193 125.018 177.587C125.956 196.98 172.685 230.813 175.361 210.987C178.037 191.16 174.105 193.567 159.191 160.283C144.277 127 168.145 104.497 158.869 92.8806Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.584 297.68C312.854 288.251 306.577 295.81 273.025 280.846C230.924 262.07 252.392 297.938 257.164 313.095C261.936 328.252 340.867 347.076 356.478 358.622C372.088 370.169 427.856 355.397 414.198 340.778C400.539 326.16 417.643 331.215 382.433 321.7C347.224 312.185 348.314 307.109 330.584 297.68Z",
    fill: "#CA793F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.061,
    cy: 21.7419,
    r: 36.5,
    transform: "rotate(-80.882 192.061 21.7419)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.151,
    cy: 138.361,
    r: 36.5,
    transform: "rotate(-80.882 237.151 138.361)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.301,
    cy: 257.531,
    r: 36.5,
    transform: "rotate(-80.882 432.301 257.531)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.522,
    cy: 250.274,
    r: 36.5,
    transform: "rotate(-80.882 539.522 250.274)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.067,
    cy: 157.833,
    r: 36.5,
    transform: "rotate(-80.882 566.067 157.833)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.753,
    cy: 57.3083,
    r: 36.5,
    transform: "rotate(-80.882 548.753 57.3083)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.942,
    cy: 158.874,
    r: 36.5,
    transform: "rotate(-80.882 465.942 158.874)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.697,
    cy: 204.916,
    r: 36.5,
    transform: "rotate(-80.882 323.697 204.916)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.049,
    cy: 94.2316,
    r: 36.5,
    transform: "rotate(-80.882 346.049 94.2316)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.013,
    cy: 54.7204,
    r: 36.5,
    transform: "rotate(-80.882 446.013 54.7204)",
    fill: "#832120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.508 -23.0324L352.539 -12.2525C353.505 -7.88755 353.68 -3.27056 352.928 1.41167C349.734 21.3153 331.009 34.8608 311.105 31.6664C291.202 28.4719 277.656 9.74721 280.851 -10.1565C281.603 -14.8468 283.219 -19.1841 285.508 -23.0324Z",
    fill: "#832120"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1739_827",
    x: 56.5673,
    y: -366.296,
    width: 759.112,
    height: 759.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1739_827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1739_827",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaquarter);
export default __webpack_public_path__ + "static/media/pizzaquarter.cae3594793d354dfcfaae15a388e24b1.svg";
export { ForwardRef as ReactComponent };